export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Bancontact"] = "Bancontact";
    PaymentMethod["iDEAL"] = "iDEAL";
    PaymentMethod["Payconiq"] = "Payconiq";
    PaymentMethod["Transfer"] = "Transfer";
})(PaymentMethod || (PaymentMethod = {}));
export const PaymentMethodHelper = {
    getName(method) {
        switch (method) {
            case PaymentMethod.Bancontact: return "Bancontact";
            case PaymentMethod.iDEAL: return "iDEAL";
            case PaymentMethod.Payconiq: return "Payconiq by Bancontact";
            case PaymentMethod.Transfer: return "Overschrijving";
        }
    }
};
//# sourceMappingURL=PaymentMethod.js.map